import { render, staticRenderFns } from "./add_order.vue?vue&type=template&id=061fe0c0&scoped=true&"
import script from "./add_order.vue?vue&type=script&lang=js&"
export * from "./add_order.vue?vue&type=script&lang=js&"
import style0 from "./add_order.vue?vue&type=style&index=0&id=061fe0c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061fe0c0",
  null
  
)

export default component.exports